var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslateFill120Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.917 18.333 3.791-10.021h1.73l3.812 10.021H17.5l-.875-2.562h-4.063l-.895 2.562Zm3.166-4.021h2.979l-1.458-4.104h-.062Zm-9.729 1.521-1.187-1.187 4.208-4.208q-.792-.876-1.385-1.813-.594-.937-1.011-1.979h1.729q.396.75.813 1.354.417.604 1.021 1.271.937-1 1.531-2.052.594-1.052.989-2.24H.833V3.312h5.834V1.646h1.666v1.666h5.834v1.667h-2.438q-.417 1.479-1.156 2.875-.74 1.396-1.844 2.625l1.979 2.042-.625 1.708-2.562-2.562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateFill120Px);
export default __webpack_public_path__ + "static/media/translate_fill1_20px.1d89d115cefedcb1a199a4adb4f73b30.svg";
export { ForwardRef as ReactComponent };